<template>
  <div class="p16">
    <div
      class="p16 border border-radius-8 d-flex align-items-center flex-column"
    >
      <div
        class="hide-shimmer-text shimmer-container br8 rounded width60"
        :style="{ height: '40px' }"
      >
        random
      </div>
      <div
        class="hide-shimmer-text shimmer-container br8 rounded width100 mt4"
        :style="{ height: '32px' }"
      >
        random
      </div>
    </div>
    <div class="p16 border border-radius-8 mt16">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column width80">
          <div
            class="hide-shimmer-text shimmer-container br8 rounded width100"
            :style="{ height: '32px' }"
          >
            random
          </div>
          <div
            class="hide-shimmer-text shimmer-container br8 rounded width80 mt8"
            :style="{ height: '40px' }"
          >
            random
          </div>
        </div>
        <div
          class="hide-shimmer-text shimmer-container br8 rounded"
          :style="{ height: '48px', width: '48px' }"
        >
          random
        </div>
      </div>
      <div class="d-flex justify-content-between mt24">
        <div class="d-flex flex-column width80">
          <div
            class="hide-shimmer-text shimmer-container br8 rounded width100"
            :style="{ height: '32px' }"
          >
            random
          </div>
          <div
            class="hide-shimmer-text shimmer-container br8 rounded width80 mt8"
            :style="{ height: '40px' }"
          >
            random
          </div>
        </div>
        <div
          class="hide-shimmer-text shimmer-container br8 rounded"
          :style="{ height: '48px', width: '48px' }"
        >
          random
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CsatShimmer",
  mounted() {},
  methods: {},
  computed: {},
};
</script>
